import { render, staticRenderFns } from "./editProductTiktok.vue?vue&type=template&id=1cb0d150&scoped=true"
import script from "./editProductTiktok.vue?vue&type=script&lang=js"
export * from "./editProductTiktok.vue?vue&type=script&lang=js"
import style0 from "./editProductTiktok.vue?vue&type=style&index=0&id=1cb0d150&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb0d150",
  null
  
)

export default component.exports